/* eslint-disable @typescript-eslint/restrict-template-expressions */
import { apiFetch } from '../../shared/apiClient';
import LeagueStats from './types/LeagueStats';
import PlayerHighlight from './types/PlayerHighlight';
import PlayerStats from './types/PlayerStats';
import { PlayerStatsByBetTitles } from './types/PlayerStatsByBetTitles';
import { PlayerStatsByBetValues } from './types/PlayerStatsByBetValues';
import PlayerStatsByTeams from './types/PlayerStatsByTeams';

export async function getAllPlayersStatsBySeason(
	seasonId: string
): Promise<{ playersStats: PlayerStats[] }> {
	let url = `${import.meta.env.VITE_PRODUCT_SERVER}/api/stats/season/${seasonId}`;
	if (import.meta.env.VITE_PRODUCT_SERVER === 'localhost') {
		url = `/api/stats/season/${seasonId}`;
	}
	const result = await apiFetch(`${url}`);
	if (result.status >= 400) {
		const { message }: { message: string } = await result.json();
		throw new Error(message);
	}
	return result.json();
}

export async function getAllPlayersStatsByLeagues(
	seasonId: string
): Promise<{ playersStatsByLeagues: LeagueStats[] }> {
	let url = `${import.meta.env.VITE_PRODUCT_SERVER}/api/stats/season/${seasonId}/leagues`;
	if (import.meta.env.VITE_PRODUCT_SERVER === 'localhost') {
		url = `/api/stats/season/${seasonId}/leagues`;
	}
	const result = await apiFetch(`${url}`);
	if (result.status >= 400) {
		const { message }: { message: string } = await result.json();
		throw new Error(message);
	}
	return result.json();
}

export async function getAllStatsByTeamsInSeason(
	seasonId: string
): Promise<{ playersStatsByTeams: PlayerStatsByTeams[] }> {
	let url = `${import.meta.env.VITE_PRODUCT_SERVER}/api/stats/season/${seasonId}/teams`;
	if (import.meta.env.VITE_PRODUCT_SERVER === 'localhost') {
		url = `/api/stats/season/${seasonId}/teams`;
	}
	const result = await apiFetch(`${url}`);
	if (result.status >= 400) {
		const { message }: { message: string } = await result.json();
		throw new Error(message);
	}
	return result.json();
}

export async function getAllStatsByBetTitlesInSeason(
	seasonId: string
): Promise<{ playersStatsByBetTitles: PlayerStatsByBetTitles[] }> {
	let url = `${import.meta.env.VITE_PRODUCT_SERVER}/api/stats/season/${seasonId}/bet-titles`;
	if (import.meta.env.VITE_PRODUCT_SERVER === 'localhost') {
		url = `/api/stats/season/${seasonId}/bet-titles`;
	}
	const result = await apiFetch(`${url}`);
	if (result.status >= 400) {
		const { message }: { message: string } = await result.json();
		throw new Error(message);
	}
	return result.json();
}

export async function getAllStatsByBetValuesInSeason(
	seasonId: string
): Promise<{ playersStatsByBetValues: PlayerStatsByBetValues[] }> {
	let url = `${import.meta.env.VITE_PRODUCT_SERVER}/api/stats/season/${seasonId}/bet-values`;
	if (import.meta.env.VITE_PRODUCT_SERVER === 'localhost') {
		url = `/api/stats/season/${seasonId}/bet-values`;
	}
	const result = await apiFetch(`${url}`);
	if (result.status >= 400) {
		const { message }: { message: string } = await result.json();
		throw new Error(message);
	}
	return result.json();
}

export async function getStatsByTeams(
	seasonId: string,
	leagueId: string,
	userId: string
): Promise<{ statsByTeams: PlayerStatsByTeams }> {
	let url = `${
		import.meta.env.VITE_PRODUCT_SERVER
	}/api/stats/season/${seasonId}/league/${leagueId}/user/${userId}`;
	if (import.meta.env.VITE_PRODUCT_SERVER === 'localhost') {
		url = `/api/stats/season/${seasonId}/league/${leagueId}/user/${userId}`;
	}
	const result = await apiFetch(`${url}`);
	if (result.status >= 400) {
		const { message }: { message: string } = await result.json();
		throw new Error(message);
	}
	return result.json();
}

export async function getPlayerHighlights(
	seasonId: string
): Promise<{ players: PlayerHighlight[] }> {
	let url = `${import.meta.env.VITE_PRODUCT_SERVER}/api/stats/season/${seasonId}/highlights`;
	if (import.meta.env.VITE_PRODUCT_SERVER === 'localhost') {
		url = `/api/stats/season/${seasonId}/highlights`;
	}
	const result = await apiFetch(`${url}`);
	if (result.status >= 400) {
		const { message }: { message: string } = await result.json();
		throw new Error(message);
	}
	return result.json();
}

export async function playersStatsFullRecalculation(
	seasonId: string
): Promise<{ playersStats: PlayerStats[] }> {
	let url = `${import.meta.env.VITE_PRODUCT_SERVER}/api/stats/season/${seasonId}/recalculation`;
	if (import.meta.env.VITE_PRODUCT_SERVER === 'localhost') {
		url = `/api/stats/season/${seasonId}/recalculation`;
	}
	const result = await apiFetch(`${url}`);
	if (result.status >= 400) {
		const { message }: { message: string } = await result.json();
		throw new Error(message);
	}
	return result.json();
}

// TODO: сделать позже - статистика игрока за все сезоны
export async function getAllPlayersStats(): Promise<{
	playersStats: PlayerStats[];
}> {
	let url = `${import.meta.env.VITE_PRODUCT_SERVER}/api/my/bets`;
	if (import.meta.env.VITE_PRODUCT_SERVER === 'localhost') {
		url = '/api/my/bets';
	}
	const result = await apiFetch(`${url}`);
	if (result.status >= 400) {
		const { message }: { message: string } = await result.json();
		throw new Error(message);
	}
	return result.json();
}
